import { createAction, props } from '@ngrx/store';

const GET_ALL_PROCESS = '[Process] Get All Processes';
const SET_PROCESS = '[Process] Set Processes';
const CREATE_PROCESS = '[Process] Create Process';
const UPDATE_PROCESS = '[Process] Update Process';
const DELETE_PROCESS = '[Process] Delete Process';
const ADD_PROCESS_TO_STATE = '[Process] Add Process To State';
const UPDATE_PROCESS_IN_STATE = '[Process] Update Process In State';
const CREATE_PROCESS_SUCCESS = '[Process] Create Process Success';
const CREATE_PROCESS_FAILURE = '[Process] Create Process Failure';
const DELETE_STATE_PROCESS = '[Process] Delete State Process';
const RESET_PROCESS_STATE = '[Process] Reset Process State';

const getAllProcess = createAction(GET_ALL_PROCESS, props<{ apiConstants: any; urlPathVariables: any }>());
const setProcess = createAction(SET_PROCESS, props<{ data: any }>());
const createProcess = createAction(CREATE_PROCESS, props<{ apiConstants: any; data: any }>());
const createProcessSuccess = createAction(CREATE_PROCESS_SUCCESS, props<{ data: any }>());
const createProcessFailure = createAction(CREATE_PROCESS_FAILURE, props<{ error: any }>());
const updateProcess = createAction(UPDATE_PROCESS, props<{ apiConstants: any; data: any }>());
const deleteProcess = createAction(
  DELETE_PROCESS,
  props<{ apiConstants: any; parentNodeSid: string; urlPathVariables: { componentId: string } }>()
);
const addProcessToState = createAction(ADD_PROCESS_TO_STATE, props<{ data: any }>());
const updateProcessInState = createAction(UPDATE_PROCESS_IN_STATE, props<{ data: any }>());
const deleteStateProcess = createAction(DELETE_STATE_PROCESS, props<{ data: any }>());
const resetProcessState = createAction(RESET_PROCESS_STATE);

const ProcessActions = {
  getAllProcess,
  setProcess,
  createProcess,
  updateProcess,
  deleteProcess,
  addProcessToState,
  updateProcessInState,
  createProcessSuccess,
  createProcessFailure,
  deleteStateProcess,
  resetProcessState
};

export default ProcessActions;
